import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { enable_user_account } from "../api/serverWrapper";

export const useAccountStatusGate = () => {
  const navigate = useNavigate();
  const [accountDeletedPopup, setAccountDeletedPopup] = useState(false);
  const [accountDisabledPopup, setAccountDisabledPopup] = useState(false);
  const [disabledUserId, setDisabledUserId] = useState(null);
  const [isEnabling, setIsEnabling] = useState(false);

  // Returns true if the account is blocked — callers should `return` right after.
  const checkAccountStatus = (user) => {
    if (user.IsDeleted) {
      setAccountDeletedPopup(true);
      return true;
    }
    if (!user.IsActive) {
      setDisabledUserId(user.UserId);
      setAccountDisabledPopup(true);
      return true;
    }
    return false;
  };

  const handleReactivateAccount = async () => {
    try {
      setIsEnabling(true);
      const resp = await enable_user_account({ UserId: disabledUserId });
      if (resp?.code === 200) {
        setAccountDisabledPopup(false);
        setTimeout(() => navigate("/home"), 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsEnabling(false);
    }
  };

  return {
    accountDeletedPopup,
    setAccountDeletedPopup,
    accountDisabledPopup,
    setAccountDisabledPopup,
    isEnabling,
    checkAccountStatus,
    handleReactivateAccount,
  };
};